import React from 'react';
import { Col } from 'react-grid-system';
import PropTypes from 'prop-types';
import MediaText from '../MediaText';
import Section from '../Section';

function MediaTextSection(props) {
  const {
    components,
    bgVariant,
    hasBorder,
    id,
    imageOrientation,
    imageSize,
  } = props;

  return (
    <Section hasBorder={hasBorder} fullBleed size="small">
      <Col sm={12}>
        {components.map(component => (
          <MediaText
            {...component}
            size={imageSize}
            orientation={imageOrientation}
            variant={bgVariant}
            key={id}
          />
        ))}
      </Col>
    </Section>
  );
}

export default MediaTextSection;

MediaTextSection.propTypes = {
  components: PropTypes.arrayOf(PropTypes.object),
  bgVariant: PropTypes.string,
  hasBorder: PropTypes.bool,
  id: PropTypes.string,
  imageOrientation: PropTypes.string,
  imageSize: PropTypes.string,
};

MediaTextSection.defaultProps = {
  components: null,
  bgVariant: '',
  hasBorder: false,
  id: '',
  imageOrientation: 'left',
  imageSize: '',
};
